
    import Vue from "vue";
    import { Prop, Watch, Component } from "vue-property-decorator";
    import { mask } from 'vue-the-mask';
    import * as Envios from '@lib/Ventas/Envios'
    @Component( {
        name: "Componente",
        directives: { mask },
        props: {},
        components: {}
    } )
    export default class Componente extends Vue {

        @Prop( { type: Boolean } ) public disabled: boolean;
        @Prop( { type: Boolean } ) public readonly: boolean;

        @Prop( { type: Envios.Tipos } )
        public value: Envios.Tipos;

        @Watch( 'value', { immediate: true } )
        onIndex() {
            this.Selected = this.value;
        }

        constructor() {
            super();
        }

        public items: Array<Envios.Tipos> = Envios.Tipos.Options;

        public selected: Envios.Tipos | null = null;
        public get Selected(): Envios.Tipos | null {
            return this.selected;
        }
        public set Selected( x: Envios.Tipos | null ) {
            this.selected = x;
            this.$emit( 'input', this.Selected );
        }

        public async onLostFocus( event: any ) {

        }
    }
